import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 获取党员报到列表
export function listPartyMemberReports(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/partyMemberReport.listPartyMemberReports',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 审核党员报到
export function auditPartyMemberReport(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/partyMemberReport.auditPartyMemberReport',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取党员报到详情
export function getPartyMemberReport(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/partyMemberReport.getPartyMemberReport',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
